import { useUserReviews } from '@/hooks/useReviews';
import { Avatar } from '@/components/ui/Avatar';
import { Skeleton } from '@/components/ui/Skeleton';
import { EmptyState } from '@/components/common/EmptyState';
import { formatRelativeTime } from '@/lib/format';
import styles from './ReviewsList.module.css';

interface Props {
  userId: string;
}

export const ReviewsList = ({ userId }: Props) => {
  const { data: reviews, isLoading } = useUserReviews(userId);

  if (isLoading) {
    return (
      <div className={styles.list}>
        <Skeleton width="100%" height={72} />
        <Skeleton width="100%" height={72} />
      </div>
    );
  }

  if (!reviews || reviews.length === 0) {
    return (
      <EmptyState
        title="Пока нет отзывов"
        description="Отзывы появятся после завершённых сделок"
      />
    );
  }

  return (
    <div className={styles.list}>
      {reviews.map((r) => (
        <div key={r.id} className={styles.item}>
          <Avatar src={r.author.avatar_url} name={r.author.display_name} size="sm" />
          <div className={styles.body}>
            <div className={styles.topRow}>
              <span className={styles.author}>{r.author.display_name}</span>
              <span className={styles.stars}>
                {[1, 2, 3, 4, 5].map((s) => (
                  <Star key={s} filled={s <= r.rating} />
                ))}
              </span>
            </div>
            {r.comment && <p className={styles.comment}>{r.comment}</p>}
            <span className={styles.time}>{formatRelativeTime(r.created_at)}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

const Star = ({ filled }: { filled: boolean }) => (
  <svg
    width="13" height="13" viewBox="0 0 24 24"
    className={filled ? styles.starFilled : styles.starEmpty}
    fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor"
    strokeWidth="1.5"
  >
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);